<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet" persistent>
      <template v-slot:activator="{ on: on2, attrs }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" v-bind="attrs" v-on="{ ...on, ...on2 }">
              <slot name="button">
                edit
              </slot>
            </v-icon>
          </template>
          <span>
            <slot name="tooltip-text">
              Validar numero de teléfono
            </slot>
          </span>
        </v-tooltip>
      </template>
      <v-sheet class="text-center" height="600px">
        <v-btn class="mt-6" text color="error" @click="sheet = !sheet">
          Cerrar
        </v-btn>

        <v-container
          fill-height
          class="d-flex justify-center align-content-start"
        >
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(loginWithPhone)">
              <ValidationProvider
                v-slot="{ errors }"
                name="teléfono"
                rules="required|min:13|max:13"
              >
                <v-text-field
                  v-model="myTelephoneNumber"
                  v-mask="'###-###-##-##'"
                  type="text"
                  label="Teléfono"
                  class="mb-n4"
                ></v-text-field>
                <span class="red--text">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="col-12">
                <v-btn
                  v-show="user !== undefined && user && networkOnLine"
                  class="ma-2"
                  outlined
                  type="submit"
                >
                  Validar teléfono
                </v-btn>
              </div>
              <div id="recaptcha-container"></div>
            </v-form>
          </ValidationObserver>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import store from '@/store'
import { ValidationObserver } from 'vee-validate'
import firebase from 'firebase/app'

export default {
  components: { ValidationObserver },
  data: () => ({
    myTelephoneNumber: '',
    code: '+52',
    confirmationResult: null,
    sheet: false
  }),
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('app', ['networkOnLine', 'appTitle'])
  },
  methods: {
    async loginWithPhone() {
      const applicationVerifier = new firebase.auth.RecaptchaVerifier(
        'recaptcha-container'
      )
      console.log(`${this.code}${this.myTelephoneNumber}`)
      // const provider = new firebase.auth.PhoneAuthProvider()
      firebase
        .auth()
        .signInWithPhoneNumber(
          `${this.code}${this.myTelephoneNumber}`,
          applicationVerifier
        )
        .then(confirmationResult => {
          console.log(
            '🚀 ~ file: ValidPhoneNumber.vue ~ line 93 ~ loginWithPhone ~ confirmationResult',
            confirmationResult
          )
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          this.confirmationResult = confirmationResult
          const credential = firebase.auth.PhoneAuthProvider.credential(
            confirmationResult.verificationId,
            '123456'
          )

          firebase
            .auth()
            .currentUser.linkWithCredential(credential)
            .then(usercred => {
              const { user } = usercred
              console.log('Account linking success', user)
              store.dispatch(
                'authentication/updatePhoneNumber',
                `${this.code}${this.myTelephoneNumber}`
              )
            })
            .catch(error => {
              console.log('Account linking error', error)
              // Desvincular numero de telefono
              firebase
                .auth()
                .currentUser.unlink('phone')
                .then(() => {
                  console.log(
                    '🚀 ~ file: ValidPhoneNumber.vue ~ line 126 ~ .then ~ Auth provider unlinked from account'
                  )
                  // Auth provider unlinked from account
                  // ...
                })
                .catch(err => {
                  console.log(
                    '🚀 ~ file: ValidPhoneNumber.vue ~ line 127 ~ loginWithPhone ~ error',
                    err
                  )
                  // An error happened
                  // ...
                })
            })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: ValidPhoneNumber.vue ~ line 99 ~ loginWithPhone ~ error',
            error
          )
          // Error; SMS not sent
          // ...
        })
    }
  }
}
</script>
